var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "content-loader",
    {
      attrs: {
        height: 107,
        width: 946,
        speed: 2,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb"
      }
    },
    [
      _c("rect", {
        attrs: { x: "20", y: "20", rx: "0", ry: "0", width: "65", height: "65" }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "110",
          y: "20",
          rx: "4",
          ry: "4",
          width: "220",
          height: "15"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "110",
          y: "50",
          rx: "3",
          ry: "3",
          width: "160",
          height: "10"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "440",
          y: "21.55",
          rx: "0",
          ry: "0",
          width: "90",
          height: "34"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "550",
          y: "21.55",
          rx: "0",
          ry: "0",
          width: "90",
          height: "34"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "830",
          y: "21.55",
          rx: "0",
          ry: "0",
          width: "80",
          height: "34"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ba8dd40a", { render: render, staticRenderFns: staticRenderFns })
  }
}